import { render, staticRenderFns } from "./WannaCodeReview.vue?vue&type=template&id=d2e80ee4&scoped=true&"
import script from "./WannaCodeReview.vue?vue&type=script&lang=js&"
export * from "./WannaCodeReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e80ee4",
  null
  
)

export default component.exports